import type { Filter_FacetsFragment } from '@generated/graphql'

import {
  ShowHeightFilterPaths,
  ShowLargerFilterPaths,
  HideLengthFilterPaths,
  HideLengthMediumFilterPaths,
  HideSizeFilterPaths,
} from './pathsToVerifyFilter'

interface IValidatedFacetsByPage {
  filteredFacets: Filter_FacetsFragment[] | undefined
  base?: string
}

const validatedPath = (pathToHide: string[], baseUrl?: string) => {
  return baseUrl ? pathToHide?.includes(baseUrl) : false
}

export const validatedFacetsByPage = ({
  filteredFacets,
  base,
}: IValidatedFacetsByPage) => {
  if (!validatedPath(ShowHeightFilterPaths, base)) {
    filteredFacets = filteredFacets?.filter(
      (facet) => facet?.key?.toLowerCase() !== 'altura-aprox'
    )
  }

  if (!validatedPath(ShowLargerFilterPaths, base)) {
    filteredFacets = filteredFacets?.filter(
      (facet) => facet?.key?.toLowerCase() !== 'largura-aprox'
    )
  }

  if (validatedPath(HideLengthFilterPaths, base)) {
    filteredFacets = filteredFacets?.filter(
      (facet) => facet?.key?.toLowerCase() !== 'comprimento-aprox'
    )
  }

  if (validatedPath(HideLengthMediumFilterPaths, base)) {
    filteredFacets = filteredFacets?.filter(
      (facet) => facet?.key?.toLowerCase() !== 'comprimento-aprox'
    )
  }

  if (validatedPath(HideSizeFilterPaths, base)) {
    filteredFacets = filteredFacets?.filter(
      (facet) => facet?.key?.toLowerCase() !== 'tamanho-aprox'
    )
  }

  return filteredFacets
}
